import api from '@/api/axios';

const loteModel = {
    data: {
        id: null,
        secuencia: null,
        codintlote: null,
        subasta_id: null,
        estado_lote_id: null,
        estado_lote: {

        },
        es_bien_registrable: null,
        titulo: null,
        oculto: null,
        precio_base: null,
        precio_inicial: null,
        precio_subastado: null,
        moneda: null,
        visitas: null,
        descripcion_breve: null,
        descripcion_completa: null,
        comentario_interno: null,
        tipificado_id: null,
        tipificado: {
            id: null,
            nombre: null,
            slug: null
        },
        subasta_ubicacion_id: null,
        subasta_ubicacion: {
            descripcion: null,
            pais_id: null,
            provincia_id: null,
            ciudad: null,
            direccion: null,
            se_exhibe: null,
            horarios: null,
            info: null,
        },
        created_by_id: null,
        created_by: {
            name: null,
            email: null,
        },
        updated_by_id: null,
        updated_by: {
            name: null,
            email: null,
        },
        caracteristicas: [],
        multimedia: []

    },

    async obtenerLote(id) {
        try {
            const response = await api.get(`/lotes/${id}`);
            const lote = response.data;
            this.data = Object.assign({}, this.data, lote);
            return this.data;
        } catch (error) {
            console.error("Error al obtener el lote:", error);
            throw error;
        }
    },

    async obtenerLotes(filtros = {}, subasta_id = null) {
        try {
            const response = await api.get('/lotes', {
            params: {
                ...filtros,
                ...(subasta_id ? { subasta_id } : {})
            },
            });
            return response.data;
        } catch (error) {
            console.error("Error al obtener los lotes:", error.message || error);
            throw error;
        }
    },
};

export default loteModel;